import React, { useEffect, useState } from 'react';
import Pager from './Pager';

// Pages a list that is already loaded: renders its children with the rows of the current page and, when there is more
// than one page, the pager below. Totals shown beside the table stay those of the whole list.
//   <PagedRows rows={payments}>{(rows) => <Table>… rows.map(…) …</Table>}</PagedRows>
const PagedRows = ({ rows, size = 10, children }) => {
  const [page, setPage] = useState(1);
  const count = rows.length;
  // A different list (another range, another client) starts on its first page.
  useEffect(() => { setPage(1); }, [count]);

  const pages = Math.max(1, Math.ceil(count / size));
  const current = Math.min(page, pages);
  const first = (current - 1) * size;

  return (
    <>
      {children(rows.slice(first, first + size))}
      {pages > 1 && (
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-3" style={{ gap: 8 }}>
          <span className="text-muted small">{first + 1}–{Math.min(first + size, count)} de {count}</span>
          <Pager page={current} pages={pages} onChange={setPage} />
        </div>
      )}
    </>
  );
};

export default PagedRows;
